import utils from 'utils'

class creatDeclarationCtrl {
  constructor($scope, $state, httpRequest, logger) {
    let reqObj = {}
    httpRequest.get_getOrgModel({ zsxmDm: 10101 }).then((res) => {
      if (res.data.value.length) {
        $scope.modelList = res.data.value
        $scope.select1 = $scope.modelList[0]
        httpRequest
          .get_qryOrgTaxPeriod(
            JSON.parse(localStorage.user_info).user.currentOrgId
          )
          .then((res) => {
            $scope.periodName = res.data.value.periodName
            reqObj = {
              mbuuid: $scope.select1.mbuuid,
              sbzlDm: $scope.select1.sbzlDm,
              skssq: res.data.value.periodCode,
            }
            initDeclaration(reqObj)
          })
      }
    })
    // 申报表模版切换
    $scope.modelChange = function () {
      reqObj.mbuuid = this.select1.mbuuid
      reqObj.sbzlDm = this.select1.sbzlDm
      initDeclaration(reqObj)
    }
    let sbuuid = 0
    function initDeclaration(obj) {
      httpRequest.post_sbSbqkInit(obj).then((res) => {
        if (res.data.success) {
          sbuuid = res.data.value
          httpRequest.get_getSbSbqkInfoBySbuuid(sbuuid).then((resData) => {
            $scope.data = resData.data.value
            $scope.sbshztUrl = `/static/images/sbshzt${$scope.data.sbshztDm}.png`
          })
        }
      })
    }
    // httpRequest.get_dictByTypeArr(["sbshzt_dm"]).then(res => {
    //     $scope.dictData = res.data.value;
    // })
    $scope.declarationSubmit = function () {
      httpRequest.post_submitAudit(sbuuid).then((subRes) => {
        if (subRes.data.success) {
          initDeclaration(reqObj)
          logger.logSuccess('提交成功')
        }
      })
    }
    $scope.openDetail = function openDetail(item, movement) {
      const { path } = $scope.data.mbkpz
      const obj = utils.encode(
        JSON.stringify({
          path,
          item: item.xh,
          movement,
          sbuuid,
          periodName: $scope.periodName,
          flzlmc: $scope.data.mbkpz.mbmc,
        })
      )
      const url =
        movement == 'view'
          ? 'declaration.addValTaxDeclaration.creatDeclaration.detail'
          : 'declaration.addValTaxDeclaration.creatDeclaration.edit'
      const _url = $state.href(url, { obj }, { reload: true })
      window.open(_url, '_blank')
    }
  }
}

creatDeclarationCtrl.$inject = ['$scope', '$state', 'httpRequest', 'logger']
export default creatDeclarationCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/creatDeclaration/creatDeclarationCtrl.js